// import { useRequest } from "hooks";
// import { useEffect, useState } from "react";
// import browserStorage from "services/storage/browserStorage";
import { useRequest } from "../hooks/useRequest/useRequest";

export const useCommon = () => {
  const [getDetailsClient, getDetailsData, getDetailsStatus, getDetailsError] =
    useRequest();

  const [
    getBranchesClient,
    getBranchesData,
    getBranchesStatus,
    getBranchesError,
  ] = useRequest();

  const [getCoursesClient, getCoursesData, getCoursesStatus, getCoursesError] =
    useRequest();

  const [
    getCourseDaysClient,
    getCourseDaysData,
    getCourseDaysStatus,
    getCourseDaysError,
  ] = useRequest();

  const [
    getCourseShiftsClient,
    getCourseShiftsData,
    getCourseShiftsStatus,
    getCourseShiftsError,
  ] = useRequest();

  const [
    createOrderClient,
    createOrderData,
    createOrderStatus,
    createOrderError,
  ] = useRequest();

  // const admin: any = localStorage.getItem("admin");
  // const id: any = JSON.parse(admin)?._id;

  const getDetails = async (params: string) => {
    await getDetailsClient.get(`details?${params}`);
  };

  const getBranches = async (params: string) => {
    await getBranchesClient.get(`branches`);
  };

  const getCourses = async (data: any) => {
    await getCoursesClient.post(`courses`, data);
  };

  const getCourseDays = async (data: any) => {
    await getCourseDaysClient.post(`course-days`, data);
  };

  const getCourseShifts = async (data: any) => {
    await getCourseShiftsClient.post(`course-shifts`, data);
  };

  const createOrder = async (data: any) => {
    await createOrderClient.post(`order`, data);
  };

  return {
    state: {
      getDetailsState: {
        getDetailsData,
        getDetailsStatus,
        getDetailsError,
      },
      getBranchesState: {
        getBranchesData,
        getBranchesStatus,
        getBranchesError,
      },
      getCoursesState: {
        getCoursesData,
        getCoursesStatus,
        getCoursesError,
      },
      getCourseDaysState: {
        getCourseDaysData,
        getCourseDaysStatus,
        getCourseDaysError,
      },
      createOrderState: {
        createOrderData,
        createOrderStatus,
        createOrderError,
      },
      getCourseShiftsState: {
        getCourseShiftsData,
        getCourseShiftsStatus,
        getCourseShiftsError,
      },
    },
    actions: {
      getDetails,
      getBranches,
      getCourses,
      getCourseDays,
      createOrder,
      getCourseShifts,
    },
  };
};
